export enum FETCH_STATUS {
	WAIT = "WAIT",
	PENDING = "PENDING",
	DONE = "DONE",
	FAILED = "FAILED",
	FINAL = "FINAL",
}
